import React  from 'react';

import Layout from '../components/layouts/standard-page.js';
import ContentLayout from '../components/layouts/content-standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';

import LanguageSelector from '../components/inputs/language-selector.js';
import {ListGroupItem , ListGroup , Thumbnail , Row , Col , Alert , FormGroup , ControlLabel , FormControl , Button} from 'react-bootstrap';
import ContentService from '../services/content-service.js';
import ContentStore   from  '../store/content-store.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import InternationalizationStore from '../store/internationalization-store.js';
import { FormattedMessage } from 'react-intl';
import CDNImage from '../components/media/image.js';
import CDNAudio from '../classes/audio.js';
import VocabObject from '../components/content-vocab.js';


export default class ContentBuilderCheckout extends React.Component{

    constructor(props) {
        super(props);

        this.CatalogParams = {catalogUID:this.props.params.catalogUID , learning:this.props.params.learning , support:this.props.params.support  }
        this.state = {
            catalog:ContentStore.getCatalog(this.props.params.catalogUID),
            cheackoutCatalog:ContentStore.getCatalog(this.props.params.myCalatlogUID)
        }
    }


    componentWillMount() {
        ContentService.fetchCatalog(this.CatalogParams.catalogUID , this.CatalogParams.learning , this.CatalogParams.support)
    }

    componentDidMount() {
        ContentStore.on('ON_VOCAB_FETCH'  , () => {

            this.setState({
                catalog:ContentStore.getCatalog(this.props.params.catalogUID),
                cheackoutCatalog:ContentStore.getCatalog(this.props.params.myCalatlogUID)
            })

        })
    }

    componentWillReceiveProps(props){

        var newCatalogParams = {catalogUID:props.params.catalogUID , learning:props.params.learning , support:props.params.support  }

        if(JSON.stringify(this.CatalogParams) != JSON.stringify(newCatalogParams))
        {
            this.CatalogParams = newCatalogParams
            ContentService.fetchCatalog(this.CatalogParams.catalogUID , this.CatalogParams.learning , this.CatalogParams.support);
        }
    
    }

    addAll(){

        let promises = [];

        for(var idx = 0 ; idx < this.state.catalog.vocab.length; idx++)
        {
            var send = false;

            for(var jdx = 0 ; jdx < this.state.cheackoutCatalog.vocab.length; jdx++)
            {
                if(this.state.catalog.vocab[idx].uid == this.state.cheackoutCatalog.vocab[jdx].uid)
                {
                    send = true;
                }
            }

            console.log(send)

            if(!send)
            {
                promises.push(ContentService.addVocab(this.props.params.myCalatlogUID , this.state.catalog.vocab[idx].uid));
            }

        }


        return Promise.all(promises).then(function(){
            ContentService.fetchCatalog(this.props.params.myCalatlogUID);
            ContentService.fetchCatalogSummary( this.props.params.myCalatlogUID);
        }.bind(this));
    }

    removeAll(){
        let promises = [];

        for(var idx = 0 ; idx < this.state.catalog.vocab.length; idx++)
        {
            var send = false;

            for(var jdx = 0 ; jdx < this.state.cheackoutCatalog.vocab.length; jdx++)
            {
                if(this.state.catalog.vocab[idx].uid == this.state.cheackoutCatalog.vocab[jdx].uid)
                {
                    send = true;
                }
            }



            if(send)
            {
                promises.push(ContentService.removeVocab(this.props.params.myCalatlogUID , this.state.catalog.vocab[idx].uid));
            }

        }


        return Promise.all(promises).then(function(){
            ContentService.fetchCatalog(this.props.params.myCalatlogUID);
            ContentService.fetchCatalogSummary( this.props.params.myCalatlogUID);
        }.bind(this));
    }

    render()
    {

        if(!this.state.catalog) return;

        var VocabObjects = [];

        for(var idx = 0 ; idx < this.state.catalog.vocab.length; idx++)
        {
            let vocabObject = this.state.catalog.vocab[idx];
            VocabObjects.push(<Col md={4}><VocabObject catalogUID={this.props.params.myCalatlogUID} vocab={vocabObject}/></Col>);
        }


        return <Layout>
                    <ContentLayout catalogUID={this.props.params.myCalatlogUID}>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md={12}>
                                        <Button  onClick={this.addAll.bind(this)} bsStyle={'primary'}><b><FormattedMessage id={"ui-0000"} defaultMessage={"Add All"} /></b></Button>
                                        &nbsp; &nbsp;<Button  onClick={this.removeAll.bind(this)} bsStyle={'primary'}><b><FormattedMessage id={"ui-0000"} defaultMessage={"Remove All"} /></b></Button>

                                        <br/>
                                        <br/>
                                    </Col>
                                </Row>
                                <Row>{VocabObjects}</Row>
                            </CardBody>
                        </Card>
                    </ContentLayout>
               </Layout>
    }

}


// WEBPACK FOOTER //
// ./src/screens/content-bulider-catalog.js